import { render, staticRenderFns } from "./OfferToCustomerBirthday.vue?vue&type=template&id=bdea30ce&"
import script from "./OfferToCustomerBirthday.vue?vue&type=script&lang=js&"
export * from "./OfferToCustomerBirthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports